import React, { Fragment, useContext, useEffect, useState } from "react";
import Helmet from "react-helmet";
// import 'styles/scss/SearchUser.scss';
// import 'styles/scss/ModalEditProfile.scss';
// import 'styles/scss/SectionProfile.scss';
import { NavLink, useParams } from "react-router-dom";
import { getUser } from "../../auth/services";
import { Context } from "../../../context/globalContext";
import PageNotFound from "./PageNotFound";
import { Breadcrumb, Loader } from "semantic-ui-react";
import styled from "styled-components";
import UserData from "../components/UserData";


export default function UserProfileScreen(props) {
  let { username: paramUsermane } = useParams();
  const [loadingUserSearchProfile, setLoadingUserSearchProfile] = useState(
    true
  );
  const [userSearchProfile, setUserSearchProfile] = useState({});
  const {
    graphQLClient,
    state: { user: userProfile },
  } = useContext(Context);

  useEffect(() => {
    setLoadingUserSearchProfile(true);
    if (paramUsermane !== userProfile.username) {
      getUserSearchProfile(paramUsermane);
    } else {
      setUserSearchProfile(userProfile);
      setLoadingUserSearchProfile(false);
    }
  }, [paramUsermane, userProfile]);

  async function getUserSearchProfile(username) {
    const userData = await getUser(graphQLClient, "", username);
    setUserSearchProfile({
      ...userData?.userDataHasura,
      ...userData?.userAccount,
    });
    setLoadingUserSearchProfile(false);
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{userSearchProfile.name}</title>
      </Helmet>
      {loadingUserSearchProfile ? (
        <Loader active size={"massive"} />
      ) : (
          <section id="page_content">
            {!userSearchProfile.username ? (
              <PageNotFound />
            ) : (
                <>
                  {/*<BackgroundGrey>
                    
                     <BreadcrumbContainer>
                       <Breadcrumb icon="right angle">
                         <Breadcrumb.Section link>Home</Breadcrumb.Section>
                        <Breadcrumb.Divider /> 
                        <Breadcrumb.Section active>
                          {userProfile.username === userSearchProfile.username
                            ? userSearchProfile.name
                            : userSearchProfile.username}
                        </Breadcrumb.Section>
                      </Breadcrumb> 
                    </BreadcrumbContainer>
                  </BackgroundGrey> */}
                  
                  <UserData
                    owner={userProfile.username === userSearchProfile.username}
                    userSearchProfile={userSearchProfile}
                    paramUsermane={paramUsermane}
                  />
                  
                </>
              )}
          </section>
        )}
    </>
  );
}

const BreadcrumbContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 16px 32px;
`;
const BackgroundGrey = styled.div`
  background-color: #f5f5f5;
`;